import { Outlet, useNavigate } from 'react-router-dom';
import { InitialLocationModal } from '@features/app/initial-location-modal';
import { Modal, ModalContent, ModalHeader, ModalBody } from '@heroui/react';
import { loginModalAtom } from '@app/atoms/app/app.atom.ts';
import { useAtom } from 'jotai';
import { useState } from 'react';
import { DesktopPhoneForm } from '@features/authorization/phone-form-desktop.tsx';
import { DesktopOtpForm } from '@features/authorization/otp-form-desktop.tsx';
import { useRemoteStoreValidator } from '../../entites/app/use-remote-store-validator.tsx';

export const DesktopContent = () => {
  const [isOpen, setIsOpen] = useAtom(loginModalAtom);
  const navigate = useNavigate();
  useRemoteStoreValidator();
  const [phone, setPhone] = useState<string | null>(null);
  return (
    <>
      <Outlet />

      <InitialLocationModal />

      <Modal isOpen={isOpen} onOpenChange={setIsOpen} size="xl">
        <ModalContent>
          <ModalHeader className="flex px-9 pt-9 flex-col pb-2 text-[#222222] gap-1 text-2xl font-bold">
            {phone ? 'Введите код из SMS' : 'Авторизация'}
          </ModalHeader>
          <ModalBody className="px-9 pb-9 gap-y-0">
            {phone ? (
              <p className="text-[#60656C]">
                Код подтверждения отправлен на номер:
                <br />
                {phone}
              </p>
            ) : (
              <p className="text-[#60656C]">
                Войдите, чтобы оформлять заказы и просматривать историю покупок
              </p>
            )}
            {phone ? (
              <DesktopOtpForm
                phone={phone}
                onChangePhone={() => setPhone(null)}
                onSuccess={() => {
                  setIsOpen(false);
                  navigate('/?store=validate', { replace: true });
                  window.location.reload();
                }}
              />
            ) : (
              <DesktopPhoneForm
                onClose={() => setIsOpen(false)}
                onSuccess={setPhone}
              />
            )}
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
};
